<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row
            class="process-row"
          >
            <b-col
              cols="12"
              md="6"
              class="process-title"
            >
              <div class="d-flex align-items-center">
                <h3>{{ processtitle }}</h3>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-if="filteredAPIprocessmodules.length > 0"
                  id="add-module-btn"
                  class="mr-1"
                  variant="primary"
                  @click="clickCopyProcess"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_COPY_PROCESS') }}</span>
                </b-button>
                <b-button
                  id="add-module-btn"
                  v-b-modal.modal-role
                  variant="primary"
                  @click="addMainModule(0)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_MODULE') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="filteredAPIprocessmodules.length > 0"
          >
            <b-col
              v-for="processmodule in filteredAPIprocessmodules"
              :key="processmodule.id"
              cols="12"
              md="12"
              class="main-cols"
            >
              <b-alert
                v-if="processmodule.module_id === 1 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_TYPE') }} : {{ getAwaitType(processmodule.module_settings.type) }}
                    </b-list-group-item>
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_DAYS') }} : {{ processmodule.module_settings.number_of_days }}
                    </b-list-group-item>
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_SKIP_WEEKEND') }} : {{ processmodule.module_settings.skip_monday ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
                    </b-list-group-item>
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_AWAIT_SKIP_INTEREST') }} : {{ processmodule.module_settings.skip_interest_calculation ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="(processmodule.module_id === 2 || processmodule.module_id === 9 || processmodule.module_id === 14 || processmodule.module_id === 25) && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <condition-details
                  :ref="'processmodule-'+processmodule.id"
                  :module-settings="processmodule"
                  :parent-module="processmodule.id"
                  :condition-check="conditionCheck"
                  :state="0"
                  :api-process-modules="APIprocessmodules"
                  @addChildModule="addConditionModule($event)"
                />
              </b-alert>
              <b-alert
                v-if="(processmodule.module_id === 3 || processmodule.module_id === 4) && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item>
                      {{ processmodule.module_id === 3 ? $t('DEBTIA_LETTER_TEMPLATE_TEXT') +': '+processmodule.module_settings.letter_template_title : $t('DEBTIA_EMAIL_TEMPLATE_TEXT')+': '+processmodule.module_settings.email_template_title }}
                    </b-list-group-item>
                    <b-list-group-item
                      class="list-variable-item"
                    >
                      <b-row>
                        <b-col
                          v-for="variable in processmodule.module_settings.custom_variables"
                          :key="variable.id"
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            :label="variable.custom_variable"
                            label-for="h-first-name"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>
                              {{ variable.mapped_value === 'dato_felt' ? getDatoFelto(variable.functional_value) : variable.mapped_value === 'letter_sent_date' ? `letter_sent_date (${variable.letter_order})` : variable.mapped_value }}
                              <ul v-if="variable.mapped_value === 'Conditional Mappable'">
                                <li><b>{{ $t('DEBTIA_CONDITION') }}:</b> {{ variable.condition.condition }}</li>
                                <li v-if="variable.condition.field !== null"><b>{{ $t(variable.condition.field.label) }}:</b> {{ variable.condition.field.value }}</li>
                                <li v-if="variable.condition.condition === 'Is the field filled?'"><b> {{ $t('DEBTIA_CUSTOM_VARIABLE') }}:</b> {{ variable.condition.custom_variable_value }}</li>
                                <li v-if="variable.condition.condition === 'Statements'"><b> Statements:</b> {{ variable.condition.statements }}</li>
                                <li><b>{{ $t('DEBTIA_OPERATOR') }}:</b> {{ variable.condition.operator }}</li>
                                <li><b>Value if True:</b> {{ variable.condition.true_value }}</li>
                                <li><b>Value if False:</b> {{ variable.condition.false_value }}</li>
                              </ul>
                              <ul v-else-if="variable.mapped_value === 'letter_sent_date' && variable.letters.length > 0">
                                <li
                                  v-for="(letter, index) in variable.letters"
                                  :key="index"
                                >{{ letter }}</li>
                              </ul>
                            </label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item
                      v-show="processmodule.module_settings.file_groups.length > 0"
                    >
                      {{ $t('DEBTIA_FILE_CATEGORIES') }}
                      <b-list-group-item
                        class="list-variable-item"
                      >
                        <b-row>
                          <b-col
                            v-for="fileGroup in processmodule.module_settings.file_groups"
                            :key="fileGroup.id"
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              :label="fileGroup.file_group.file_category"
                              label-for="h-first-name"
                              label-cols-md="12"
                              class="process-group"
                            />
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group-item>
                    <b-list-group-item
                      v-if="
                        processmodule.module_id === 3 &&
                          processmodule.module_settings &&
                          processmodule.module_settings.enabled_days
                      "
                    >
                      <b>{{ $t('DEBTIA_SEND_DAYS') }}</b>
                      {{ formattedDays(processmodule.module_settings.enabled_days) }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="(processmodule.module_id === 5 || processmodule.module_id === 6) && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ processmodule.module_id === 5 ? 'Process' : 'Action' }}: {{ processmodule.module_id === 5 ? getState(processmodule.module_settings.new_process_id) : processmodule.module_settings.reason }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 7 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_FEE') }} : {{ processmodule.module_settings.reminder_fee }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 8 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="list-variable-item"
                    >
                      <b-row>
                        <b-col
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            label-for="recipient"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>
                              {{ $t('DEBTIA_RECIPIENT') }} : {{ processmodule.module_settings.recipient }}
                            </label>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            label-for="subtotal"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>
                              {{ $t('DEBTIA_SUBTOTAL') }} : {{ processmodule.module_settings.subtotal }}
                            </label>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            label-for="vat_amount"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>
                              {{ $t('DEBTIA_VATAMOUNT') }} : {{ processmodule.module_settings.vat_amount }}
                            </label>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            label-for="total"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>
                              {{ $t('DEBTIA_TOTAL') }} : {{ processmodule.module_settings.total }}
                            </label>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            label-for="await_payment"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>
                              {{ $t('DEBTIA_AWAIT_PAYMENT') }} : {{ processmodule.module_settings.await_payment === 1 ? 'True' : 'False' }}
                            </label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_INVOICE_PRODUCTS') }}
                      </b-list-group-item>
                      <b-list-group-item
                        class="list-variable-item"
                      >
                        <b-row>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <label>{{ $t('DEBTIA_PRODUCT_NAME') }}</label>
                            </b-form-group>
                          </b-col>

                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <label>{{ $t('DEBTIA_QUANTITY') }}</label>
                            </b-form-group>
                          </b-col>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <label>{{ $t('DEBTIA_UNIT_PRICE') }}</label>
                            </b-form-group>
                          </b-col>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <label>{{ $t('DEBTIA_TOTAL_PRICE') }}</label>
                            </b-form-group>
                          </b-col>
                        </b-row>

                      </b-list-group-item>
                      <b-list-group-item
                        v-for="(variable, i) in processmodule.module_settings.get_products"
                        :key="variable.id"
                        class="list-variable-item"
                      >
                        <b-row>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              :label="variable.custom_variable"
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <span>{{ i+1 }} - {{ variable.product_name }}</span>
                            </b-form-group>
                          </b-col>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              :label="variable.custom_variable"
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <span>{{ variable.quantity }}</span>
                            </b-form-group>
                          </b-col>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              :label="variable.custom_variable"
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <span>{{ variable.unit_price }}</span>
                            </b-form-group>
                          </b-col>
                          <b-col

                            cols="12"
                            md="3"
                            class="group-col"
                          >
                            <b-form-group
                              :label="variable.custom_variable"
                              label-cols-md="12"
                              class="process-group text-center"
                            >
                              <span>{{ variable.total_price }}</span>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 10 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_TASK_LIST') }} : {{ processmodule.module_settings.title }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>

              <b-alert
                v-if="processmodule.module_id === 11 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      A Compensation Fee of 310 per Invoice Document will be charged.
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>

              <b-alert
                v-if="processmodule.module_id === 12 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      Collection Cost will be auto calculated.
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>

              <b-alert
                v-if="processmodule.module_id === 13 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_COLLECTION_FEE') }} : {{ processmodule.module_settings.collection_fee }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>

              <b-alert
                v-if="processmodule.module_id === 15 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item>
                      {{ $t('DEBTIA_CUSTOM_FIELD_DATA_MODULE') }}
                    </b-list-group-item>
                    <b-list-group-item
                      class="list-variable-item"
                    >
                      <b-row>
                        <b-col
                          v-for="variable in processmodule.module_settings"
                          :key="variable.id"
                          cols="12"
                          md="4"
                          class="group-col"
                        >
                          <b-form-group
                            :label="$t(variable.label)"
                            label-for="h-first-name"
                            label-cols-md="12"
                            class="process-group"
                          >
                            <label>{{ variable.value === 'dato_felt' ? getDatoFelto(variable.functional_value) : variable.value }}</label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 16 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_APPLY_TERMSHEET_TO') }} : {{ processmodule.module_settings ? processmodule.module_settings.termsheet_for : 'N/A' }}
                    </b-list-group-item>
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_TERMSHEET') }} : {{ processmodule.module_settings ? processmodule.module_settings.termsheet : 'N/A' }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="(processmodule.module_id === 17) && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <condition-details
                  :ref="'processmodule-'+processmodule.id"
                  :module-settings="processmodule"
                  :parent-module="processmodule.id"
                  :condition-check="conditionCheck"
                  :state="0"
                  :api-process-modules="APIprocessmodules"
                  @addChildModule="addConditionModule($event)"
                />
              </b-alert>
              <b-alert
                v-if="(processmodule.module_id === 18) && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_OPERATOR') }} : {{ processmodule.module_settings ?
                        processmodule.module_settings.bailiff_status === 1 ? "True" : "False"
                        : 'N/A' }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 19 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ processmodule.module_settings.court }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 20 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ processmodule.module_settings.message }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 21 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_REASON') }}: {{ getDebtiaReason(processmodule.module_settings.reason) }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>

              <b-alert
                v-if="processmodule.module_id === 22"
                variant="primary"
                show
                class="mt-2"
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_BAILIFF_PROCESS') }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 23"
                variant="primary"
                show
                class="mt-2"
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      {{ $t('DEBTIA_DEFAULT_OVERVAGNING_TERMSHEET') }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
              <b-alert
                v-if="processmodule.module_id === 24 && processmodule.depends_on === 0"
                variant="primary"
                show
                class="mt-2"
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item class="main-items">
                      {{ $t('DEBTIA_QUESTION') }}: {{ processmodule.module_settings.question }}
                    </b-list-group-item>
                    <b-list-group-item class="main-items">
                      {{ $t('DEBTIA_DESCRIPTION') }}: {{ processmodule.module_settings.description }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>

              <b-alert
                v-if="processmodule.module_id === 26 && processmodule.depends_on === 0"
                variant="primary"
                show
              >
                <h4 class="alert-heading">
                  {{ processmodule.module_title }}
                </h4>
                <div class="alert-body">
                  <b-list-group
                    flush
                    class="awaitlist"
                  >
                    <b-list-group-item
                      class="main-items"
                    >
                      Active Installment Plan will be deactivated.
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-alert>
            </b-col>
          </b-row>
          <b-row
            v-else
          >
            <b-col
              cols="12"
              md="12"
            >
              <b-alert
                variant="warning"
                show
              >
                <h4 class="alert-heading">
                  {{ $t('DEBTIA_NO_MODULE_MSG') }}
                </h4>
              </b-alert>
            </b-col>
          </b-row>
        </div>
        <add-module-modal
          :condition-variant="conditionVariant"
          :condition-check="conditionCheck"
          :main-condition="maincondition"
          @refreshprocess="getProcess($event)"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BCard, BOverlay, BAlert, BListGroup, BListGroupItem, BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
import AddModuleModal from './AddModuleModal.vue'
import ConditionDetails from './ConditionDetails.vue'
// import UserActionDetails from './UserActionDetails.vue'

const DEBTIA_REASON_DESCRIPTIONS = {
  BET: 'Fordring betalt',
  AIN: 'Aftale indgået med skyldner',
  DØD: 'Skyldner er afgået ved døden',
  TFY: 'Tvangsakkord fyldestgjort',
  GAL: 'Gældssanering – al gæld bortfalder',
  VTT: 'Varen taget retur',
  TAF: 'Tvangsauktion aflyst',
  STR: 'Der er strid i sagen',
  DER: 'Andet – vi ønsker skyldner slettet',
}

export default {
  components: {
    BFormGroup,
    BButton,
    BRow,
    BCol,
    BCard,
    BOverlay,
    AddModuleModal,
    BAlert,
    BListGroup,
    BListGroupItem,
    ConditionDetails,
    // UserActionDetails,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      conditionLoader: false,
      processtitle: '',
      APIprocessmodules: [],
      filteredAPIprocessmodules: [],
      dependedModules: [],
      initialState: {
        depends_on: 0,
        parentID: 0,
      },
      awaitmoduleadded: false,
      processes: [],
      caseReasonOptions: [],
      conditionDiv: 0,
      conditionVariant: {},
      conditionCheck: true,
      maincondition: true,
    }
  },
  created() {
    this.getProcesses()
    this.getCaseReasonOptions()
    this.getProcess(this.initialState)
    EventBus.$on('addModuleInButton', obj => {
      this.conditionVariant = obj
      this.conditionCheck = !this.conditionCheck
    })
    EventBus.$on('expandDetailsInConditionModule', obj => {
      this.$refs[`processmodule-${obj.main}`][0].expandfunction(obj)
    })
    EventBus.$on('refreshBack', obj => {
      this.$refs[`processmodule-${obj.main}`][0].expandCondition(obj.id)
    })
  },
  methods: {
    clickCopyProcess() {
      this.$router.push({ name: 'process-copy-view', params: { id: this.$route.params.id } })
    },
    getProcesses() {
      const url = '/process/list?perPage=100000000&q=&page='
      axios.get(url).then(response => {
        if (response.status) {
          const records = response.data.data.processes.data
          // console.log('records are ', records)
          records.forEach(element => {
            const elementObj = { label: element.title, value: element.id }
            this.processes.push(elementObj)
          })
        }
      })
    },
    addConditionModule(event) {
      this.conditionVariant = event
      this.conditionCheck = !this.conditionCheck
    },
    addMainModule(id) {
      const obj = {
        moduleID: id,
        type: 0,
      }
      this.conditionVariant = obj
      this.conditionCheck = !this.conditionCheck
    },
    getProcess(event) {
      if (event.depend > 0) {
        this.$refs[`processmodule-${event.parentID}`][0].refreshModule(event.type)
      } else {
        this.loader = true
        const processID = this.$route.params.id
        const url = `/process/get/${processID}`
        this.filteredAPIprocessmodules = []
        axios.get(url).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.processtitle = response.data.data.process.title
            this.APIprocessmodules = response.data.data.process_modules
            this.APIprocessmodules.forEach(element => {
              if (element.depends_on === 0) {
                this.filteredAPIprocessmodules.push({ ...element })
              }
            })
            this.APIprocessmodules.forEach(element => {
              if (element.depends_on !== 0) {
                this.dependedModules.push({ ...element })
              }
            })
          }
        })
      }
    },
    getAwaitType(type) {
      const awaittype = type === 1 ? 'Time Based' : 'Action Based'
      return awaittype
    },
    getState(id) {
      let processTitle = ''
      processTitle = this.processes.filter(entry => entry.value === id)
      return processTitle[0].label
    },
    getReason(id) {
      let reasonTitle = ''
      reasonTitle = this.caseReasonOptions.filter(entry => entry.value === id)
      return reasonTitle[0].label
    },
    getDebtiaReason(code) {
      const description = DEBTIA_REASON_DESCRIPTIONS[code]
      return description ? `${code} - ${description}` : code
    },
    async getCaseReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
    getDepenededModules(id) {
      const arr = this.dependedModules.filter(element => element.depends_on === id)
      return arr
    },
    getDatoFelto(number) {
      // eslint-disable-next-line no-nested-ternary
      return Number(number) === 0 ? 'dags dato' : (Number(number) >= 1 ? `dags dato (+${number} dage)` : `dags dato (${number} dage)`)
    },
    formattedDays(enabledDays) {
      if (!enabledDays) return ''

      // If "all" is true → return full week
      if (enabledDays.all) {
        return [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ].join(', ')
      }

      const daysMap = {
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
      }

      return Object.keys(daysMap)
        .filter(day => enabledDays[day])
        .map(day => daysMap[day])
        .join(', ')
    },
  },
}
</script>

<style lang="scss">
.process-row{
  border-top: 1px solid #e4f2f1;
  border-radius: 10px;
  box-shadow: rgb(33 146 137 / 40%) 0px 6px 15px -7px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.process-title{
  margin-top: 6px;
}

.awaitlist {
  border-radius: 10px;
}

.form-row.form-group.process-group {
  margin-bottom: 0px;
}

.form-row.form-group.process-group label{
  padding-bottom: 0px;
}

.group-col {
  border-bottom: 1px solid #ececec;
  padding-bottom: 5px;
}

.list-variable-item{
  padding-top: 0px;
}

.row-yes-no {
  margin-top: 5px;
}

.yes-no {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.split-div .list-group-item.yes-no{
  background-color: #badcdc;
}

.yes-no:hover {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.column-no {
  padding-right: 3px;
}

.column-yes {
  padding-left: 3px;
}

.condition-head {
  display: inline-block;
}

.condition-head-left {
  margin-top: 10px;
}

.condition-head-right {
  float: right;
}

.option-btn .btn.btn-outline-primary:first-child {
  padding: 10px 40px;
}

.list-group-item.main-items {
  text-align: center;
}

.condition-heading-title h4 {
  font-weight: 600;
  font-size: 1.1rem;
  color: inherit;
}

.collapse-icon.collapse-default .card .card-header {
  background-color: #f7f7f7;
}

.nested-condition-module {
  border: 1px solid #e4f2f1;
}

.nested-module {
  margin-bottom: 5px !important;
}

.expand-btn {
  width: 100%;
  margin-top: 10px;
}

.expand-feather {
  top: 0px !important;
}
.main-cols{margin-bottom: 4rem;}
.main-cols:before{
  position: absolute;
  content: '';
  left: 50%;
  transform: translateX(-50%);
  top: 100%;
  width: 40px;
  height: 40px;
  background: url('~@/assets/images/icons/down-arrow-1.png') no-repeat 50% 50% / 30px;
  margin: 0.6rem 0 0;
}
.main-cols .alert{margin-bottom: 0;}
.main-cols:last-child{margin-bottom: 0;}
.main-cols:last-child:before{display: none;}

</style>
